// extracted by mini-css-extract-plugin
export var darkThemeButton = "Menu-module--darkThemeButton--fe19d";
export var expanded = "Menu-module--expanded--ae131";
export var hasSubmenu = "Menu-module--hasSubmenu--0b341";
export var item = "Menu-module--item--61c33";
export var lightThemeButton = "Menu-module--lightThemeButton--3153b";
export var menu = "Menu-module--menu--6879d";
export var menuToggle = "Menu-module--menuToggle--a6002";
export var root = "Menu-module--root--60042";
export var subitem = "Menu-module--subitem--f2993";
export var submenu = "Menu-module--submenu--d591b";